module.exports = __webpack_public_path__ + "assets/media/arrow.667c01ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/SchedulingCardPreview/arrow.svg
// module id = 2602
// module chunks = 0